import axios from "axios";

export const CLOUD_API_BASE_URL = "https://dnbinderapi.pruebasistemasgenius.com";

const normalizeBaseUrl = (value) => String(value || "").trim().replace(/\/+$/, "");

const LOCAL_API_FALLBACKS = new Set([
  "http://127.0.0.1:3220",
  "http://localhost:3220",
]);

const resolvePreferredApiBaseUrl = () =>
  normalizeBaseUrl(process.env.REACT_APP_DEV_API_BASE_URL) ||
  normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL) ||
  CLOUD_API_BASE_URL;

const resolveApiBaseUrl = (baseURL) => {
  const normalizedBaseUrl = normalizeBaseUrl(baseURL);
  if (!normalizedBaseUrl) return resolvePreferredApiBaseUrl();
  if (LOCAL_API_FALLBACKS.has(normalizedBaseUrl)) {
    return resolvePreferredApiBaseUrl();
  }

  return normalizedBaseUrl;
};

const clearStoredSession = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    localStorage.removeItem("binderUser");
    localStorage.removeItem("binderDeposito");
  } catch {
    // Ignore storage cleanup errors.
  }
};

export const getAccessToken = () => {
  if (typeof window === "undefined") return "";

  try {
    return String(localStorage.getItem("token") || "").trim();
  } catch {
    return "";
  }
};

export const buildAuthenticatedUrl = (url) => {
  const token = getAccessToken();
  if (!token) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}access_token=${encodeURIComponent(token)}`;
};

export const createApiClient = (config = {}) => {
  const api = axios.create({
    ...config,
    baseURL: resolveApiBaseUrl(config.baseURL),
  });

  api.interceptors.request.use((requestConfig) => {
    const nextConfig = {
      ...requestConfig,
      headers: {
        ...(requestConfig.headers || {}),
      },
    };

    const token = getAccessToken();
    if (token && !nextConfig.headers.Authorization) {
      nextConfig.headers.Authorization = `Bearer ${token}`;
    }

    return nextConfig;
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        clearStoredSession();
        if (typeof window !== "undefined" && window.location.pathname !== "/") {
          window.location.assign("/");
        }
      }

      return Promise.reject(error);
    }
  );

  return api;
};

export default axios;
